import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`text-${_vm.textVariant}`},[_c('a',{attrs:{"href":"https://help.mythulu.ink/","target":"_blank"}},[_vm._v(" https://help.mythulu.ink/ "),_c(VIcon,{attrs:{"x-small":"","dark":_vm.dark}},[_vm._v("mdi-open-in-new")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }